import {
  StripePaymentIntentStatus,
  StripeDisputeStatus,
  StripePayoutStatus,
  StripeInvoiceStatus,
} from 'shared/types/graphql';

export const StatusDescription: Record<string, string> = {
  [StripePaymentIntentStatus.Canceled]: 'Canceled',
  [StripePaymentIntentStatus.Created]: 'Invoiced',
  [StripePaymentIntentStatus.Processing]: 'Processing',
  [StripePaymentIntentStatus.RequiresAction]: 'Action Required',
  [StripePaymentIntentStatus.RequiresCapture]: 'Pre-Authorized',
  [StripePaymentIntentStatus.RequiresConfirmation]: 'Confirmation Required',
  [StripePaymentIntentStatus.RequiresPaymentMethod]: 'Invoiced',
  [StripePaymentIntentStatus.Succeeded]: 'Complete',

  [StripeDisputeStatus.ChargeRefunded]: 'Refunded',
  [StripeDisputeStatus.Lost]: 'Lost',
  [StripeDisputeStatus.NeedsResponse]: 'Response Required',
  [StripeDisputeStatus.UnderReview]: 'Under Review',
  [StripeDisputeStatus.WarningClosed]: 'Closed',
  [StripeDisputeStatus.WarningNeedsResponse]: 'Warning Response Required',
  [StripeDisputeStatus.WarningUnderReview]: 'Warning Under Review',
  [StripeDisputeStatus.Won]: 'Won',

  [StripePayoutStatus.Canceled]: 'Canceled',
  [StripePayoutStatus.Failed]: 'Failed',
  [StripePayoutStatus.InTransit]: 'Pending',
  [StripePayoutStatus.Paid]: 'Disbursed',
  [StripePayoutStatus.Pending]: 'Pending',

  [StripeInvoiceStatus.Draft]: 'Draft',
  [StripeInvoiceStatus.Open]: 'Open',
  [StripeInvoiceStatus.Paid]: 'Paid',
  [StripeInvoiceStatus.Uncollectible]: 'Uncollectible',
  [StripeInvoiceStatus.Void]: 'Void',
  Refund: 'Refund',
};
